import { View } from 'components/View'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import hasSuccessStatusReduxUtil from 'modules/redux/utils/has-success-status'
import { TRAINING_PLAN_KEY } from 'modules/training/models/plan/constants'
import getNamePlanUtil from 'modules/training/models/plan/utils/get-name'
import React from 'react'
import PlanMediaImage from 'containers/Plan/PlanMediaImage'
import { IMAGE_ASPECT_RATIO_ID } from 'components/Image/constants'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import TrendingIconOverlay from 'components/TrendingIconOverlay/index.js'
import isTrendingModelUtil from 'models/utils/is-trending/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import { getByIdPlanSelector } from '@gymaholic/packages'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { ListRowItemWithImage } from 'components/ListRowItemWithImage/index.js'
import { getImageStyleListRowItemUtil } from 'components/ListRowItemWithImage/utils/get-image-style/index.js'
import TextCondensed from 'components/TextCondensed.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import { defineMessages } from 'react-intl'
import { ArrowRightIcon } from 'components/Icon/icons/arrow-right/index.js'
import Row from 'components/Row.js'
import getPathnamePlanUtil from 'modules/plan/redux/utils/get-pathname/index.js'
import TextBodySmaller from 'components/TextBodySmaller.js'

const ANALYTIC_EVENT = {
  VIEW_PLAN_ROW: 'VIEW_PLAN_ROW'
}

const messages = defineMessages({
  weeksCount: {
    id: 'PlanRow.weeksCount',
    defaultMessage: '{count} {count, plural, one {Week} other {Weeks}}'
  },
  workoutsCount: {
    id: 'PlanRow.workoutsCount',
    defaultMessage: '{count} {count, plural, one {Workout} other {Workouts}}'
  }
})

/**
 * Renders a plan row.
 * The plan should already be loaded by the route (via performLoadPlanWorkoutByIdAction).
 *
 * @param id - plan ID
 * @param parent - parent component for analytics
 * @returns {JSX.Element}
 * @constructor
 */
export function PlanRow ({
  id,
  parent
}) {
  const intl = useIntl()
  const value = useSelector(getByIdPlanSelector(id))

  const handleClick = () => {
    logEventAnalyticsUtil(
      parent
        ? getActionStrReduxUtil(parent, ANALYTIC_EVENT.VIEW_PLAN_ROW)
        : ANALYTIC_EVENT.VIEW_PLAN_ROW
    )
  }

  const renderImage = () => {
    const id = getIdReduxUtil(value)
    const width = 80
    const isTrending = !!isTrendingModelUtil(value)

    const elem = (
      <View
        style={{
          width,
          position: 'relative'
        }}
      >
        {!!isTrending && <TrendingIconOverlay />}

        <PlanMediaImage
          id={id}
          aspectRatio={IMAGE_ASPECT_RATIO_ID.TALL}
          style={getImageStyleListRowItemUtil()}
        />
      </View>
    )

    return elem
  }

  if (!value) {
    return <></>
  }

  if (!hasSuccessStatusReduxUtil(value)) {
    return <></>
  }

  const imageElement = renderImage()

  return (
    <ListRowItemWithImage
      onClick={handleClick}
      imageElement={imageElement}
      url={getPathnamePlanUtil(value)}
      mt={null}
    >
      <View
        ml={2}
        style={{ textAlign: 'left' }}
      >
        <Row>
          <View f>
            <TextCondensed>
              {getNamePlanUtil(value)}
            </TextCondensed>

            <Row>
              <TextBodySmaller>
                {
                  formatMessageIntlUtil(intl,
                    messages.workoutsCount, {
                      count: getValueReduxUtil(
                        value,
                        TRAINING_PLAN_KEY.WORKOUTS_COUNT
                      )
                    }
                  )
                }
              </TextBodySmaller>

              <View ml>
                <TextBodySmaller>
                  {
                    formatMessageIntlUtil(intl,
                      messages.weeksCount, {
                        count: getValueReduxUtil(
                          value,
                          TRAINING_PLAN_KEY.WEEKS_COUNT
                        )
                      }
                    )
                  }
                </TextBodySmaller>
              </View>
            </Row>
          </View>

          <ArrowRightIcon />
        </Row>
      </View>
    </ListRowItemWithImage>
  )
}
